// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/kube_events.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import { KubeEventsService } from "./kube_events_pb";

/**
 * @generated from rpc chalk.server.v1.KubeEventsService.ListKubeEvents
 */
export const listKubeEvents = KubeEventsService.method.listKubeEvents;

/**
 * @generated from rpc chalk.server.v1.KubeEventsService.GetKubeEventFacets
 */
export const getKubeEventFacets = KubeEventsService.method.getKubeEventFacets;

/**
 * @generated from rpc chalk.server.v1.KubeEventsService.GetKubeEventFacetValues
 */
export const getKubeEventFacetValues = KubeEventsService.method.getKubeEventFacetValues;

/**
 * @generated from rpc chalk.server.v1.KubeEventsService.ListKubeEventsAggregated
 */
export const listKubeEventsAggregated = KubeEventsService.method.listKubeEventsAggregated;

/**
 * GetKubeEventAggregates computes arbitrary aggregations (count distinct, dedup-aware sum/avg of
 * the occurrence Count, ...) grouped by 0-3 kube-event facets.
 *
 * @generated from rpc chalk.server.v1.KubeEventsService.GetKubeEventAggregates
 */
export const getKubeEventAggregates = KubeEventsService.method.getKubeEventAggregates;

/**
 * GetKubeEventStat reduces the matched events to one scalar for a dashboard statistic tile.
 *
 * @generated from rpc chalk.server.v1.KubeEventsService.GetKubeEventStat
 */
export const getKubeEventStat = KubeEventsService.method.getKubeEventStat;
